/*
 * @Author: Nanxing Xiang
 * @Date: 2021-04-02 10:17:48
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-04-02 10:20:26
 * @Description: file content
 */
export var memorize = fn => {
  var memo;
  return () => {
    if (!memo) memo = fn();
    return memo;
  };
};